import { useState } from 'react';
import emptyIMG from '@/assets/imgs/misc/temp.svg';
import { cn } from '@/lib/utils';

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  className?: string;
}

export const Image = ({ className, src, ...props }: ImageProps) => {
  const [loaded, setLoaded] = useState(false);
  const imageSrc = src || emptyIMG;

  return (
    <figure
      className={cn(
        'inline-block align-top opacity-0 overflow-hidden transition-opacity',
        loaded && 'opacity-100',
        className || '',
      )}
    >
      <img
        draggable={false}
        onLoad={() => {
          setLoaded(true);
        }}
        className={cn('object-contain w-full h-full')}
        src={imageSrc}
        {...props}
      />
    </figure>
  );
};
